// extracted by mini-css-extract-plugin
module.exports = {"Bob":"Bob_Bob__3HOpS"};